module.exports = __webpack_public_path__ + "img/hr-hazard-concrete-right.49a2d66f.png";